import React from "react";
import { ThemeProvider } from "styled-components";

const baseTheme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!../scss/themeVariables/base.scss');
const altTheme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!../scss/themeVariables/alt.scss');

const Themed = ({ alt, children }) => {
    let theme = alt ? altTheme : baseTheme;

    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    );
};

export default Themed;  


// WEBPACK FOOTER //
// ./src/helpers/Themed.js